import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function querySchedule(): Promise<Schedule> {
  const res = await fetchOrchidAPI(
    "/api/scheduler/v1/orchid_pro/available_time_periods",
  );
  if (!res.ok) {
    throw new Error(
      `failed to fetch schedule: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
